import _ from "lodash";
import { useEffect } from "react";

type OnEventProp<T> = (event: MessageEvent<T>) => void;
type Options = {
  match?: object;
};

const useMessage = <T = any>(onEvent: OnEventProp<T>, options?: Options) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent<T>) => {
      if (options?.match && !_.isMatch(event, options.match)) {
        return;
      }

      onEvent(event);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onEvent, options]);
};

export default useMessage;
